module.exports = __webpack_public_path__ + "static/media/canine-tumor-map.3876e15e.jpg";